var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-star"},_vm._l((5),function(item){return _c('span',{key:(item),staticClass:"l-img",class:{show: item <= _vm.star}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }